import * as React from 'react'
import styled from 'styled-components'

const Status = styled.p`
  padding: 0.59375rem 1rem;
  position: relative;
  margin-top: 0;
  margin-bottom: 0.625rem;
  font-size: 0.875rem;
  transition-property: padding, margin;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);
  // overflow: hidden;

  &::before {
    content: ' ';
    display: block;
    border-radius: var(--border-radius-form);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${props =>
      props.variant === 'error'
        ? 'var(--color-error)'
        : 'var(--color-primary)'};
    opacity: 0.1;
  }

  &:empty {
    padding-top: 0;
    padding-bottom: 0;
    margin: 0;
  }
`

function FormStatus(props) {
  const { children, ...restProps } = props

  return <Status {...restProps}>{children}</Status>
}

FormStatus.defaultProps = {
  // TODO: specify default props
}

FormStatus.propTypes = {
  // TODO: specify prop types
}

export default FormStatus
